<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <div class="animate__animated animate__slideInDown">
      <div v-if="isSuccessful == false">
        <div class="login-header">
          <h1 class="login-title">Change your password here</h1>
          <p class="login-subtitle">Submit details below to change your password</p>
        </div>
        <form role="form" @submit.prevent="userdata">
          <div class="form-group">
            <label class="form-label" for="password">Password</label>
            <input type="password" id="newpasswordval" class="form-input" v-model="newpasswordval"
              placeholder="Enter new password" required>
          </div>

          <div class="form-group">
            <label class="form-label" for="retypepasswordval">Password</label>
            <input type="password" id="retypepasswordval" class="form-input" v-model="retypepasswordval"
              placeholder="Retype new password" required>
          </div>

          <div class="text-center">
            <button type="submit" class="login-button">
              Submit <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </form>
      </div>
      <div class="" v-else>
        <div class="login-header">
          <h1 class="login-title">Great</h1>
          <p class="login-subtitle">Your password has been changed successfully</p>
        </div>

        <div class="signup-link text-center">
          <router-link to="/login" class="btn btn-outline-dark"><i class="fa fa-arrow-left"></i> Back to
            Login</router-link>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
import PageSpinner from "@/components/PageSpinner"
import RandomWord from "@/mixins/random-word-generator.mixin"
import Alert from "@/mixins/Alert.mixins"
export default {
  name: "change-default-password",
  mixins: [RandomWord, Alert],
  components: { PageSpinner },
  data() {
    return {
      username: "",
      retypepasswordval: "",
      newpasswordval: "",
      isSuccessful: false,
      onloader: "none",
    };
  },
  methods: {
    userdata() {
      let retypepassword = this.retypepasswordval;
      let newpassword = this.newpasswordval;
      if (retypepassword == newpassword) {
        let username = this.$store.state.auth.username;
        let password = `${this.RandomStringNumber(30)}${process.env.VUE_APP_ENV_PWDPAD}${btoa(newpassword)}`;
        let payload = {
          username,
          password
        };
        this.onloader = "flex";
        this.$store
          .dispatch("auth/ChangeDefaultPassword", payload)
          .then((resp) => {
            this.onloader = "none";
            if (resp.responseCode == '00') {
              this.isSuccessful = true;
              this.ShowAlertSuccess(resp.responseMessage, '');
            } else {
              this.isSuccessful = false;
              this.ShowAlertError(resp.responseMessage, '');
            }
          })
          .catch((err) => {
            this.onloader = "none";
            this.isSuccessful = false;
            this.ShowAlertError(err.response.data, '');
          });
      } else {
        this.isSuccessful = false;
        this.ShowAlertError('Password Mismatched', '');
      }
    },
  },
};
</script>

<style scoped>
 .login-header {
            margin-bottom: 40px;
        }

        .login-title {
            font-size: 32px;
            font-weight: 700;
            color: #333;
            margin-bottom: 10px;
        }

        .login-subtitle {
            color: #777;
            font-size: 16px;
        }

        .form-group {
            margin-bottom: 20px;
        }

        .form-label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
            color: #555;
        }

        .form-input {
            width: 100%;
            padding: 14px;
            border: 1px solid #ddd;
            border-radius: 8px;
            font-size: 16px;
            transition: all 0.3s ease;
        }

        .form-input:focus {
            border-color: #6a11cb;
            box-shadow: 0 0 0 2px rgba(106, 17, 203, 0.2);
            outline: none;
        }

        .remember-forgot {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 25px;
        }

        .remember-me {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .forgot-password {
            color: #6a11cb;
            text-decoration: none;
            font-weight: 500;
        }

        .forgot-password:hover {
            text-decoration: underline;
        }

        .login-button {
            width: 100%;
            padding: 14px;
            background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
            color: white;
            border: none;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
        }

        .login-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(106, 17, 203, 0.4);
        }

</style>
